module.exports = __webpack_public_path__ + "img/3.860ae247.jpg";